import { Breadcrumbs } from './Breadcrumbs';
import { Separator, SidebarHeader, SidebarTrigger, useSidebar } from '@ibsys/kit';
import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { cn, type RouteConfig, useCurrentRouteConfig } from '@/shared/lib';
import { Spotlight } from '@/widgets/Spotlight';
import { ProfileDropdown } from './ProfileDropdown/ProfileDropdown';
import { Tooltip, useMainLayout } from '@/shared/ui';
import { useHasPermission } from '@/entities/profile';
import { SidebarIcon } from 'lucide-react';

type Props = {
  menuItems: RouteConfig[];
};

export const MainHeader: FC<Props> = ({ menuItems }) => {
  const { t } = useTranslation(['common']);
  const config = useCurrentRouteConfig(menuItems);

  const {
    controls: { controls },
  } = useMainLayout();
  const { isMobile, openMobile } = useSidebar();

  const showDevFeatures = useHasPermission('DEVELOPMENT');

  // Переключатель назван действием, доступным сейчас: открытое меню он сворачивает,
  // свёрнутое — разворачивает
  const toggleMenuLabel = openMobile ? t('common:collapseNavigationMenu') : t('common:expandNavigationMenu');

  return (
    <SidebarHeader
      className={
        ' sticky top-0 px-0 z-10 min-h-14 md:min-h-18 h-15 md:h-18 py-0 md:py-2 flex-row items-center border-b border-border bg-sidebar'
      }
    >
      <header className={cn('md:h-16 flex items-center p-2 md:p-4 pr-10 w-full')}>
        {isMobile && (
          <Tooltip tooltip={toggleMenuLabel}>
            <SidebarTrigger aria-label={toggleMenuLabel}>
              <SidebarIcon />
            </SidebarTrigger>
          </Tooltip>
        )}
        {config && <Breadcrumbs config={config} className={'px-4'} />}
        <div className={'flex gap-4  ml-auto items-center h-full'}>
          {controls.map((control) => (
            <Fragment key={control.key}>{control.element}</Fragment>
          ))}
          {!!controls.length && <Separator orientation={'vertical'} className={'shrink-0'} />}
          {showDevFeatures && <Spotlight />}
          <ProfileDropdown />
        </div>
      </header>
    </SidebarHeader>
  );
};
